import React from "react";
import { numberWithCommas } from "lib/utils";
import { icon_notice_n } from "../../styles/img";

function HanaHeader({ point = 0 }) {
  const handleClickHeader = () => {
    if (window.confirm("하나머니로 이동하시겠습니까?")) {
    }
  };
  return (
    <>
      <div
        className="top_name"
        // onClick={() => handleClickHeader()}
        style={{ zIndex: 1 }}
      >
        <span className="left">사용가능 하나머니 </span>
        <span className="right">
          <span
            style={{
              width: "70%",
              display: "inline-block",
              wordBreak: "break-all",
            }}
          >
            {numberWithCommas(point)}
          </span>
        </span>
      </div>
      <div className="main_info_txt">
        <img src={icon_notice_n} alt="icon" />
        신용카드로 충전한 하나머니는 사용가능 하나머니에서 제외됩니다.
      </div>
    </>
  );
}

export default HanaHeader;
